import { render } from "./dialogSalesman.vue?vue&type=template&id=0aaa0347&scoped=true"
import script from "./dialogSalesman.vue?vue&type=script&lang=js"
export * from "./dialogSalesman.vue?vue&type=script&lang=js"

import "./dialogSalesman.vue?vue&type=style&index=0&id=0aaa0347&scoped=true&lang=css"

import exportComponent from "/Users/ittiwutwongsawat/Documents/GitHub/clinic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aaa0347"]])

export default __exports__